// import styles from './.FilterBoxComponents.module.css';

// const SearchSizeFilter = ( {searchSize, setSearchSize}) => {
    
//     return ( 
// <div className={styles.accordionContent}>
// {/* Content to display when accordion is open */}
//     <label>Custom Search Size</label>
//     <input type="text" aria-label='Custom Search Size' className={styles.filterInput} value={searchSize} onChange={(e) => setSearchSize(e.target.value)}/>
// </div> 
//     );
// }
 
// export default SearchSizeFilter;

// import styles from './.FilterBoxComponents.module.css';

// const SearchSizeFilter = ({ searchSize, setSearchSize }) => {
    
//     // Define the allowed search sizes
//     const allowedSizes = [2500, 5000, 10000, 25000, 50000];

//     return ( 
//         <div className={styles.accordionContent}>
//             {/* Content to display when accordion is open */}
//             <label>Custom Search Size</label>
            
//             <select 
//                 className={styles.filterInput} 
//                 value={searchSize} 
//                 onChange={(e) => setSearchSize(Number(e.target.value))}
//                 aria-label='Custom Search Size'
//             >
//                 {allowedSizes.map((size) => (
//                     <option key={size} value={size}>
//                         {size.toLocaleString()}
//                     </option>
//                 ))}
//             </select>
//         </div> 
//     );
// }
 
// export default SearchSizeFilter;

import { useState } from 'react';
import styles from './.FilterBoxComponents.module.css';

const SearchSizeFilter = ({ searchSize, setSearchSize }) => {
    const [isOpen, setIsOpen] = useState(false);
    
    // The allowed options
    const allowedSizes = [2500, 5000, 10000, 25000, 50000];

    const handleSelect = (value) => {
        setSearchSize(value);
        setIsOpen(false); // Close dropdown after selection
    };

    return ( 
        <div className={styles.accordionContent}>
            <label>Custom Search Size</label>
            
            {/* The Trigger Box (Looks like the input, acts like a button) */}
            <div 
                className={styles.filterInput} 
                onClick={() => setIsOpen(!isOpen)}
                // Inline style needed to make the div behave/look interactive like a select
                style={{ 
                    cursor: 'pointer', 
                    display: 'flex', 
                    justifyContent: 'space-between', 
                    alignItems: 'center' 
                }}
            >
                {/* Show formatted number */}
                <span>{searchSize ? searchSize.toLocaleString() : allowedSizes[0].toLocaleString()}</span>
                
                {/* Visual arrow to indicate it is a dropdown */}
                {/* <span >▼</span> */}
                {
                <svg className={styles.dropdownArrow} style={{ height: '10px', marginRight: '5px'}} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><path d="M137.4 374.6c12.5 12.5 32.8 12.5 45.3 0l128-128c9.2-9.2 11.9-22.9 6.9-34.9s-16.6-19.8-29.6-19.8L32 192c-12.9 0-24.6 7.8-29.6 19.8s-2.2 25.7 6.9 34.9l128 128z"/></svg> 
            }
            </div>

            {/* The Dropdown List - Only shows if isOpen is true */}
            {isOpen && (
                <ul className={styles.dropdown}>
                    {allowedSizes.map((size) => (
                        <li 
                            key={size}
                            className={styles.dropdownItem}
                            onClick={() => handleSelect(size)}
                        >
                            {size.toLocaleString()}
                        </li>
                    ))}
                </ul>
            )}
        </div> 
    );
}
 
export default SearchSizeFilter;